import { isValueSet } from "common/utils";
import { PriceSummaryItemKind, PriceSummary } from "common/types/priceSummary";
import { getSummaryItems } from "common/utils/summary";
import { WalletType } from "common/types";

type SummaryItemWithAmount = {
  kind: PriceSummaryItemKind;
  label: string;
  amount: number;
  value: string;
};

export const getWalletPaymentItems = <T extends PriceSummary>(data: T) =>
  // total will be rendered separately so we remove it here to avoid repeating it
  getSummaryItems<T>(data)
    .filter(
      (pi): pi is SummaryItemWithAmount =>
        isValueSet(pi.amount) && pi.kind !== PriceSummaryItemKind.Total,
    )
    .map((pi) => ({ label: pi.label, amount: pi.amount }));

/**
 * We want to support one checkout button for either apple pay or google pay for now
 * Let's filter out the supported wallets just in case other's appear which should also
 * match the general logic we get from stripe elements for the WalletPaymentButton.
 */
export const resolveSupportedWalletByPriority = (
  supportedWallets: Set<WalletType>,
): WalletType | undefined => {
  const walletPriorityOrder = [WalletType.APPLE, WalletType.GOOGLE];

  return walletPriorityOrder.find((wallet) => supportedWallets.has(wallet));
};

type WalletMetadata = {
  label: string;
};

const walletToMetadata: Record<WalletType, WalletMetadata> = {
  [WalletType.APPLE]: { label: "Apple Pay" },
  [WalletType.GOOGLE]: { label: "Google Pay" },
  [WalletType.SAMSUNG]: { label: "Samsung Pay" },
  [WalletType.MASTERPASS]: { label: "Masterpass" },
  [WalletType.AMEX_EXPRESS]: { label: "Amex Express" },
  [WalletType.VISA_CHECKOUT]: { label: "Visa Checkout" },
};

export const walletDisplayText = (supportedWallets: WalletType): string => {
  return walletToMetadata[supportedWallets].label;
};
